import React from 'react';
import { Environment } from '@react-three/drei';

// ── AN HDRI THAT CANNOT TAKE THE APP DOWN ────────────────────────────────────
//
// drei's `Environment preset="..."` fetches its HDRI from a GitHub raw URL at
// runtime. That host RATE-LIMITS: it starts answering 429, the loader throws
// inside the render tree, and because a thrown promise/error in a Three.js
// scene is not caught by anything above it, the whole application unmounts to
// a red error screen.
//
// It became common the moment published designs started opening inside the
// feed: several people opening several posts is several fetches of the same
// file from the same address in quick succession.
//
// This is a boundary, not a fix for the fetch. The HDRI only drives
// reflections and a little ambient bounce, so losing it costs some polish and
// nothing else — the scene's own lights are separate. Failing quietly is
// strictly better than a blank page where a room should be.
//
// The real fix is to serve the file ourselves rather than from someone else's
// CDN; until then this makes it survivable.
// AN ERROR BOUNDARY DOES NOT HELP HERE, which is worth writing down because it
// looks like it should. The failure arrives from the loader's async `onError`
// callback, not from a render — and a boundary only catches what is thrown
// while React is rendering. The first attempt at this wrapped `Environment` in
// exactly such a boundary and the red screen kept appearing.
//
// So the request is simply not made. The preset is the ONLY part of the scene
// that reaches out to the network at runtime, and it contributes image-based
// reflections and a little ambient bounce on top of lights the scene already
// has of its own. Losing it is a small loss of polish; a viewer that dies on a
// rate-limited third-party CDN is not survivable at all.
//
// TO RESTORE IT PROPERLY: put the HDRIs in `public/hdri/` and pass
// `files="/hdri/apartment.hdr"` instead of `preset`, then flip this to true.
// Served from our own origin there is nothing to rate-limit and nothing to
// fail. That is the real fix; this is the stop-gap.
const USE_REMOTE_HDRI = false;

function SafeEnvironment(props) {
  if (!USE_REMOTE_HDRI) return null;
  return <Environment {...props} />;
}

export default SafeEnvironment;
